/* Import External Modules */
import React from 'react';

/* Import Leverege Modules*/
import { GlobalState, Select } from '@leverege/ui-redux';
import { Dialog, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';

/* Import Local Modules */
import Icons from "../Icons.js";
const {
  t
} = I18N.ns('userManagement.user.RemoveUsersDialog');

/**
 * Removes the userIds from the given action.
 */
async function onRemoveUsers({
  data
}) {
  // Get parameters
  const {
    userIds,
    actions,
    onClose
  } = data;

  // Try to remove users
  try {
    await GlobalState.dispatch(actions.users().remove({
      userId: userIds
    }));
    await GlobalState.dispatch(Select.clear('resourceUsersTargeted'));
  } catch (error) {
    Toast.error(t('toastError'), error.message);
    return onClose();
  }

  // Successfully removed users
  Toast.success(t('toastSuccess', {
    count: userIds.length
  }));
  onClose();
}

/**
 * Remove users dialog.
 */
export default function RemoveUsersDialog(props) {
  // Get parameters
  const {
    onClose,
    show,
    userIds,
    deviceName
  } = props;
  const numUsers = userIds?.length || 0;
  const userString = t('userString', {
    count: numUsers
  });

  // Render component
  return /*#__PURE__*/React.createElement(Dialog.Question, {
    show: show,
    eventData: props,
    title: t('title'),
    icon: Icons.removeUserDialogIcon,
    message: t('message', {
      userString,
      deviceName
    }),
    okay: t('okay'),
    okayVariant: "primaryDestructive",
    onCancel: onClose,
    onOkay: onRemoveUsers
  });
}